module.exports = __webpack_public_path__ + "img/greyTestCase.c56e6459.svg";